import { isClientSide } from '~/utils/is-client-side'

const QUALIFICATION_KEY = 'nwwp_lead_magnet_qualified'

export const INVESTABLE_ASSETS_OPTIONS: { value: string; label: string }[] = [
  { value: 'UNDER_100K', label: 'Under $100,000' },
  { value: 'FROM_100_TO_250K', label: '$100,000 – $250,000' },
  { value: 'FROM_250_TO_500K', label: '$250,000 – $500,000' },
  { value: 'FROM_500K_TO_1M', label: '$500,000 – $1,000,000' },
  { value: 'OVER_1M', label: 'Over $1,000,000' },
]

export function isLeadMagnetQualified(
  household_income: number | undefined,
  investable_assets_range: string | undefined
): boolean {
  return (
    (household_income ?? 0) >= 100_000 &&
    investable_assets_range !== undefined &&
    investable_assets_range !== 'UNDER_100K'
  )
}

export function saveLeadMagnetQualification(isQualified: boolean): void {
  if (!isClientSide()) return
  try {
    window.sessionStorage.setItem(QUALIFICATION_KEY, JSON.stringify(isQualified))
  } catch {
    // Storage can be blocked (private mode, quota, disabled) — not fatal.
  }
}

export function loadLeadMagnetQualification(): boolean {
  if (!isClientSide()) return false
  try {
    const raw = window.sessionStorage.getItem(QUALIFICATION_KEY)
    if (raw === null) return false
    return raw === 'true'
  } catch {
    return false
  }
}
